export const { gettext, pgettext, ngettext } = window
// Make interpolate() always use named placeholders
const i = window.interpolate
export const interpolate = (s, p) => i(s, p, true)

export function onReady(fn, hx = false) {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1)
  } else {
    document.addEventListener("DOMContentLoaded", fn)
  }
  if (hx) {
    document.addEventListener("htmx:afterSettle", fn)
  }
}

export const qs = (s, el = document) => el.querySelector(s)
export const qsa = (s, el = document) =>
  Array.prototype.slice.call(el.querySelectorAll(s))
